export const environment = {
  production: false,
  baseUrl: "https://api.sttrand.com",
  formspeeEndpoint: "https://formspree.io/f/mrgnravn",
};
